import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Event from '../Event/Event';
import EventTypes from '../../../enums/EventTypesEnum';
import { classes } from './ShowMore.st.css';
var ShowMore = function (_a) {
    var moreEventsCount = _a.moreEventsCount, handleClick = _a.handleClick, calendarWidth = _a.calendarWidth, handleShowMoreEnter = _a.handleShowMoreEnter, isMobile = _a.isMobile, experiments = _a.experiments, localeToggle = _a.localeToggle, privetEventsTitle = _a.privetEventsTitle;
    var t = useTranslation()[0];
    var showMoreText = "+ ".concat(moreEventsCount);
    if (calendarWidth > 750) {
        showMoreText =
            moreEventsCount === 1
                ? t('Google_Calendar_One_More')
                : t('Google_Calendar_More', { amount: moreEventsCount });
    }
    return (React.createElement("div", { className: classes.root, onClick: handleClick, onKeyPress: function (e) { return e.key === 'Enter' && handleShowMoreEnter(); } },
        React.createElement(Event, { isMobile: isMobile, title: showMoreText, type: EventTypes.ShowMore, experiments: experiments, localeToggle: localeToggle, privetEventsTitle: privetEventsTitle })));
};
export default ShowMore;
//# sourceMappingURL=ShowMore.js.map